import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getModel } from './selectors';
import * as actions from './actions';
import DialogToast from './DialogToast';

const DialogToastContainer = ({ model, actions }) => {
    return model.toast
        ? <DialogToast
            show
            variant={model.toast.variant}
            message={model.toast.message}
            durationMs={model.toast.durationMs}
            animateProgress={model.toast.animateProgress}
            showCloseIcon={model.toast.showCloseIcon}
            onClose={actions.closeDialogToast}
            testId='dialog-toast'
        />
        : null;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DialogToastContainer);
